export default {
  stric: true,
  namespaced: true,
  state: {
    bookings: []
  },
  getters: {
    bookings: (state, getters) => {
      return state.bookings
    }
  },
  mutations: {
    addBooking: (state, payload) => {
      state.bookings.push(payload)
    },
    removeBookings: state => {
      state.bookings = []
    }
  }
}
